var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cookie__link",attrs:{"href":_vm.url,"target":"_blank"}},[_c('span',{staticClass:"cookie__link-label",domProps:{"innerHTML":_vm._s(_vm.label)}})])}
var staticRenderFns = []

export { render, staticRenderFns }